<!-- Pedidos Pendientes -->
<span *ngIf="pedidosPendientes?.clientes?.length > 0">

    <div class="animated fadeIn">
        <div class="card shadow-lg border-0 rounded-4 overflow-hidden h-100"
             style="background: rgba(255, 255, 255, 0.9); backdrop-filter: blur(10px);">
            <div class="card-body">
                <h5 class="card-title text-secondary"><i class="mdi mdi-cart-outline"></i> Pedidos Pendientes</h5>
                <div style="display: block; max-height: 400px; overflow-y: auto;"
                     class="pr-2">
                    <div *ngFor="let cliente of pedidosPendientes.clientes"
                         class="mb-3">
                        <div class="d-flex justify-content-between mb-1">
                            <small class="text-truncate"
                                   style="max-width: 70%;"
                                   [title]="cliente.cliNombre"><strong>{{ cliente.cliNombre | uppercase }}</strong></small>
                            <small class="text-muted">{{ cliente.num_pedidos }}</small>
                        </div>
                        <div class="progress"
                             style="height: 12px;">
                            <div class="progress-bar progress-bar-striped progress-bar-animated"
                                 [ngClass]="cliente.colorClass"
                                 role="progressbar"
                                 [style.width.%]="(cliente.num_pedidos / maxPedidos) * 100"
                                 [attr.aria-valuenow]="cliente.num_pedidos"
                                 aria-valuemin="0"
                                 [attr.aria-valuemax]="maxPedidos">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</span>